import { gql } from "@apollo/client";

export const DefaultServiceTaskOptions = gql`
    query DefaultServiceTaskOptions ($pagination: Pagination) {
        defaultServiceTaskList {
            total
            defaultServiceTasks (pagination: $pagination) {
                id
                name
            }
        }
    }
`;
